import { Instagram, Linkedin, Facebook, Youtube, Globe, Link as LinkIcon, MessageCircle, ArrowUpRight } from "lucide-react";
import { SOCIALS, waLink, WHATSAPP_DISPLAY, LOGO_URL } from "@/lib/brand";

const ICONS = { instagram: Instagram, linkedin: Linkedin, facebook: Facebook, youtube: Youtube, globe: Globe, linktree: LinkIcon, whatsapp: MessageCircle };

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative border-t border-white/10 bg-[#070806] pt-20 pb-10 overflow-hidden">
      <div className="absolute -top-20 right-1/2 translate-x-1/2 w-[600px] h-[200px] rounded-full bg-[#d4ff4f]/10 blur-[120px]" />

      <div className="relative max-w-[1400px] mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-10 mb-16">
          {/* Brand */}
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-12 h-12 rounded-xl bg-black border border-white/10 overflow-hidden p-1">
                <img src={LOGO_URL} alt="Digi Savvy" className="w-full h-full object-contain" />
              </div>
              <div className="font-display text-xl tracking-tight">DIGI SAVVY</div>
            </div>
            <h3 className="font-display text-3xl sm:text-4xl md:text-5xl tracking-tighter leading-[0.95] mb-6">
              Ready to sell<br />your project <span className="italic text-[#d4ff4f]">faster?</span>
            </h3>
            <a
              href={waLink("Hi Digi Savvy! I'd like to book a Growth Call.")}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-cta"
              className="inline-flex items-center gap-2 bg-[#d4ff4f] text-black font-semibold px-6 py-3.5 rounded-full hover:bg-white transition group"
            >
              Book a Growth Call
              <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition" />
            </a>
          </div>

          {/* Contact */}
          <div className="lg:col-span-3">
            <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-white/40 mb-4">/ Get in Touch</div>
            <ul className="space-y-3 text-sm">
              <li>
                <a href={`https://wa.me/919818825449`} target="_blank" rel="noreferrer" className="text-white/80 hover:text-[#d4ff4f] inline-flex items-center gap-2" data-testid="footer-whatsapp">
                  <MessageCircle className="w-4 h-4 text-[#25D366]" /> WhatsApp · {WHATSAPP_DISPLAY}
                </a>
              </li>
              <li>
                <a href="tel:+919818825449" className="text-white/80 hover:text-[#d4ff4f]" data-testid="footer-phone">
                  Call · {WHATSAPP_DISPLAY}
                </a>
              </li>
              <li>
                <a href="https://digisavvyy.com/" target="_blank" rel="noreferrer" className="text-white/80 hover:text-[#d4ff4f]">
                  digisavvyy.com
                </a>
              </li>
              <li className="text-white/60">Sector 3, Rohini, Delhi, 110085</li>
            </ul>
          </div>

          {/* Socials */}
          <div className="lg:col-span-4">
            <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-white/40 mb-4">/ Follow Us Everywhere</div>
            <div className="grid grid-cols-2 gap-2">
              {SOCIALS.map((s) => {
                const Icon = ICONS[s.icon] || Globe;
                return (
                  <a
                    key={s.name}
                    href={s.href}
                    target="_blank"
                    rel="noreferrer"
                    data-testid={`footer-social-${s.icon}`}
                    className="group flex items-center gap-3 px-4 py-3 rounded-xl border border-white/10 hover:border-[#d4ff4f]/50 hover:bg-[#d4ff4f]/[0.04] transition"
                  >
                    <Icon className="w-4 h-4 text-[#d4ff4f]" />
                    <span className="text-sm text-white/80 group-hover:text-white">{s.name}</span>
                    <ArrowUpRight className="w-3 h-3 ml-auto text-white/30 group-hover:text-[#d4ff4f] group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition" />
                  </a>
                );
              })}
            </div>
          </div>
        </div>

        {/* Big wordmark */}
        <div className="border-t border-white/10 pt-12">
          <div className="font-display text-[18vw] sm:text-[14vw] tracking-tighter leading-[0.85] text-transparent bg-clip-text bg-gradient-to-b from-white/15 to-transparent select-none pointer-events-none">
            DIGISAVVY
          </div>
        </div>

        <div className="mt-8 text-xs text-white/40">
          © {new Date().getFullYear()} Digi Savvy · Real-Estate Marketing Agency · All rights reserved.
        </div>
      </div>
    </footer>
  );
}
